module.exports = __webpack_public_path__ + "static/media/aluWall3.4bb85e77.jpeg";